import { render, staticRenderFns } from "./business-card.vue?vue&type=template&id=2476c5e4"
import script from "./business-card.vue?vue&type=script&lang=ts"
export * from "./business-card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports